import {
  faArrowLeft,
  faEnvelope,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import ProcessLoading from "../components/processLoading";
import { useAuth } from "../context/AuthContext";
import "../styles/authentification.css";

const Connexion = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [modalState, setModalState] = useState({
    show: false,
    loading: false,
    success: false,
    message: "",
  });

  const [infoModalState, setInfoModalState] = useState({
    show: false,
  });

  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    motDePasse: "",
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setModalState({
      show: true,
      loading: true,
      success: false,
      message: "Veuillez patienter, votre connexion est en cours...",
    });

    try {
      const response = await fetch(
        "https://boutiqu.transfoafricainc.com/api/client/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include", // si vous utilisez des sessions côté serveur
          body: JSON.stringify({
            email: formData.email,
            password: formData.motDePasse,
          }),
        }
      );

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage);
      }

      const data = await response.json(); // Récupère le token + client

      console.log("Connexion: Données reçues du serveur:", data);

      // 💾 Utiliser le contexte d'authentification
      login(data.client, data.token);

      console.log("Connexion: Utilisateur connecté via contexte");

      // ✅ Succès
      setModalState({
        show: true,
        loading: false,
        success: true,
        message: "Connexion réussie ! Redirection en cours...",
      });

      // Rediriger après un petit délai
      setTimeout(() => {
        console.log("Connexion: Redirection vers /administrations");
        navigate("/order/stats");
      }, 1000);
    } catch (error) {
      console.error("Erreur de connexion:", error.message);
      setModalState({
        show: true,
        loading: false,
        success: false,
        message: `Erreur : ${error.message}`,
      });
    }
  };

  const closeModal = () => {
    setModalState((prev) => ({ ...prev, show: false }));
  };

  const showInfoModal = (e) => {
    e.preventDefault();
    setInfoModalState({ show: true });
  };

  const closeInfoModal = () => {
    setInfoModalState({ show: false });
  };
  return (
    <div className="container-partenariat container-fluid p-0">
      <div className="row g-0 min-vh-100">
        {/* Section Gauche - Formulaire */}
        <div className="col-lg-6 d-flex align-items-center p-5 light-Mode">
          <div className="w-100">
            <a
              href="#"
              onClick={showInfoModal}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FontAwesomeIcon icon={faArrowLeft} width={"50px"} />
            </a>
            <h1
              className="mb-3"
              style={{ textAlign: "center", fontWeight: "lighter" }}
            >
              <strong style={{ color: "#0d6efd" }}>C</strong>onnexion
            </h1>
            <br></br>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="motDePasse" className="form-label">
                  Mot de passe
                </label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="motDePasse"
                    name="motDePasse"
                    value={formData.motDePasse}
                    onChange={handleChange}
                    required
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
                <Link
                  to={"/reinitialisation"}
                  style={{ textDecoration: "none" }}
                >
                  <h6>mot de passe oublié?</h6>
                </Link>
              </div>
              <br></br>

              <button
                type="submit"
                className="btn w-100 py-3 mb-3 hover-primary"
              >
                Se connecter
              </button>

              <div className="text-center">
                <a
                  href="#"
                  onClick={showInfoModal}
                  className="text-decoration-none"
                >
                  <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                  je n'ai pas de compte
                </a>
              </div>
            </form>
          </div>
        </div>

        {/* Section Droite - Étude de cas */}
        <div className="col-lg-6 section-etude-cas">
          <div className="superposition-etude p-5 d-flex flex-column justify-content-between h-100">
            <div
              style={{
                margin: "0 auto",
                marginTop: "40px",
              }}
            >
              <img
                src={logo}
                alt="logo transfo africa"
                style={{ width: "200px", height: "100px" }}
              />
            </div>
            <div>
              <blockquote
                className="citation mb-5"
                style={{ marginTop: "-20px" }}
              >
                <p className="mb-0 fs-3">
                  <strong style={{ color: "#0d6efd" }}>Transfo Africa</strong>{" "}
                  est une entreprise exerçant exclusivement dans le secteur des
                  nouvelles technologies de l’information. Nous vous proposons
                  des services tels que la sécurité des systèmes informatiques
                  et réseaux, le développement d’applications web et mobile et
                  les solutions cloud.
                </p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
      {/* Modal de chargement */}
      <ProcessLoading
        show={modalState.show}
        loading={modalState.loading}
        success={modalState.success}
        message={modalState.message}
        onClose={closeModal}
        autoCloseDelay={3000} // Ferme automatiquement après 3s si succès
        onAutoClose={closeModal}
      />

      {/* Modal d'information */}
      {infoModalState.show && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ color: "#0d6efd" }}>
                  <strong>Information importante</strong>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeInfoModal}
                  aria-label="Fermer"
                ></button>
              </div>
              <div className="modal-body">
                <p className="mb-3">
                  Pour accéder à cette interface, vous devez absolument vous
                  connecter à un compte existant. Aucune inscription directe
                  n'est autorisée à ce niveau.
                </p>
                <p className="mb-0">
                  Rendez-vous sur notre boutique en ligne accessible sur le lien{" "}
                  <a
                    href="https://boutique.transfoafrica.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#0d6efd", textDecoration: "none" }}
                  >
                    https://boutique.transfoafrica.com
                  </a>{" "}
                  pour consulter notre catalogue.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={closeInfoModal}
                >
                  Compris
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {infoModalState.show && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default Connexion;
